import React from 'react';
import { Button } from '../Buttons';
import { BodyNormal, H5 } from '../Typography';
import { NoResultViewContainer, NoResultViewContent, SearchErrorImage, SearchErrorImageContainer, TextContainer } from './NoResultViewStyles';
import SearchErrorIcon from './assets/SearchError.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NoResultView = _ref => {
  let {
    title,
    description,
    showClearFilterButton,
    onClearFiltersClick
  } = _ref;
  return /*#__PURE__*/_jsxs(NoResultViewContainer, {
    children: [/*#__PURE__*/_jsxs(NoResultViewContent, {
      children: [/*#__PURE__*/_jsx(SearchErrorImageContainer, {
        children: /*#__PURE__*/_jsx(SearchErrorImage, {
          src: SearchErrorIcon,
          alt: "search-error-icon"
        })
      }), /*#__PURE__*/_jsxs(TextContainer, {
        children: [/*#__PURE__*/_jsx(H5, {
          as: "h3",
          children: title
        }), /*#__PURE__*/_jsx(BodyNormal, {
          children: description
        })]
      })]
    }), showClearFilterButton && /*#__PURE__*/_jsx(Button, {
      onClick: onClearFiltersClick,
      children: "Clear filters"
    })]
  });
};
export default NoResultView;